import { ViewMode } from '@/sections/Workspace/types';
import localStorageEffect from '@/utils/recoil/localStorageEffect';
import { atomFamily } from 'recoil';

import { WorkspaceSections } from './types';

const viewModeState = atomFamily<ViewMode, WorkspaceSections>({
  default: ViewMode.List,
  key: 'workspace-view-mode',
  effects: (section) => [localStorageEffect(`n-workspace-view-mode-${section}`)],
});

const filterQueryState = atomFamily<string, WorkspaceSections>({
  default: '',
  key: 'workspace-filter-query',
});

const pinnedIdsState = atomFamily<string[], string /* section + userId */>({
  key: 'workspace-pinned-ids',
  default: [],
  effects: (section) => [localStorageEffect(`workspace-pinned-ids-${section}`)],
});

export { viewModeState, filterQueryState, pinnedIdsState };
